import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { isPlatformServer } from "@angular/common";
import { ProfileService, LocalService, AuthService } from "../../../core";

@Component({
  selector: "app-email-verify",
  templateUrl: "./email-verify.component.html",
  styleUrls: ["./email-verify.component.scss"],
})
export class EmailVerifyComponent implements OnInit {
  emailType: string = "";
  verificationToken: string = "";
  chalgStatus: string = "";
  chgVerificationToken: string = "";
  notificationTypeId: string = "";
  challengeName: string = "";

  showError: boolean = false;
  showHomeRoute: boolean = false;
  showApprove: boolean = false;
  showDenied: boolean = false;
  showCommentSection: boolean = false;
  isSalesManager: boolean = false;
  unsubscribeUserFlag: boolean = false;

  ChgApproveMsg: string = "";
  emailNotificationTypeName: string = "";
  userComments: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    private profileService: ProfileService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    this.emailType = this.route.snapshot.params["type"];
    this.verificationToken = this.route.snapshot.params["token"];
    this.chalgStatus = this.route.snapshot.params["status"];
    this.chgVerificationToken = this.route.snapshot.params["verification-token"];
    this.notificationTypeId = this.route.snapshot.params["notificationTypeId"];

    if (this.emailType === "verify") {
      this.verifyEmail();
    } else if (this.emailType === "approved" || this.emailType === "denied") {
      this.approveUserRole();
    } else if (this.chalgStatus != "" && this.chalgStatus != undefined) {
      this.showStatusAndCommentSection();
    } else if (this.notificationTypeId) {
      this.emailNotificationTypeName = "show";
    } else {
      this.router.navigate(["/"]);
    }
  }

  approveUserRole() {
    this.profileService
      .approveUserRole(this.emailType, this.verificationToken)
      .subscribe(
        (data: any) => {
          this.isSalesManager = data.roleToBeApproved.name === "SALES_MANAGER";
          this.showApprove = this.emailType === "approved";
          this.showDenied = this.emailType === "denied";
        },
        () => {
          this.showError = true;
        }
      );
  }

  showStatusAndCommentSection() {
    this.showCommentSection = true;
  }

  approveChallenge() {
    const reqParams = {
      verificationToken: this.chgVerificationToken,
      status: this.chalgStatus.toUpperCase(),
      comments: this.userComments,
      approverCcoId: "",
    };
    this.profileService.approveChallenge(reqParams).subscribe(
      (data: any) => {
        this.showCommentSection = false;
        if (data.tokenCheck == "SUCCESS") {
          this.challengeName = data.customChallenge.name;
          this.ChgApproveMsg =
            "Thank you! Your approval decision for the sales challenge <strong>" +
            this.challengeName +
            "</strong> is successfully submitted.";
        }
        if (data.tokenCheck == "ALREADY_USED") {
          this.ChgApproveMsg =
            "<strong>Oops!</strong> This approval link is no longer valid.";
        }
      },
      () => {
        this.showError = true;
        this.showCommentSection = false;
      }
    );
  }

  verifyEmail() {
    this.profileService.verifyEmail(this.verificationToken).subscribe(
      () => {
        this.showHomeRoute = true;
      },
      () => {
        this.showError = true;
      }
    );
  }

  unsubscribeUser() {
    const param = "?notificationTypeId=" + this.notificationTypeId;
    this.profileService.unsubscribeUser(param).subscribe((response: any) => {
      if (response) {
        this.unsubscribeUserFlag = true;
      }
    });
  }

  contactSupport() {
    this.router.navigateByUrl("/support");
  }

  logoutUser() {
    LocalService.flush("token");
    LocalService.flush("userProfile");
    LocalService.flush("selectedLanguage");
    LocalService.flush("selectedFile");
    this.authService.clearAll();
    window.location.href = "/";
  }
}
